{
  "hero": {
    "eyebrow": "科学",
    "title": "为何移动、与位置关联的监测很重要。",
    "lead": "水质会在空间上变化，也会在降雨后变化。AquaWorks 将可重复的路线读数转化为学生可解读的地图与趋势——但不宣称实验室级确证。"
  },
  "problem": {
    "title": "背景与问题",
    "body": "人工采样往往只能覆盖少数固定点。在与雨水系统相连的环境中，降雨可将沉积物、道路来源颗粒、营养物等带入池塘与受纳水体。相距数米的条件可能不同，暴雨后还会迅速变化。",
    "points": [
      "区域研究表明轮胎衍生化学物（如 6PPD-醌）与降雨后银鲑急性影响相关——说明径流路径为何重要。",
      "营养污染可在湖、塘与近岸水体引发藻华与低氧。",
      "浊度是第一阶段实用的现场指标：悬浮颗粒影响生境，也可携带磷、金属等污染物。"
    ]
  },
  "campus": {
    "title": "温哥华校园的雨水背景",
    "body": "温哥华校园的综合雨水管理计划与可持续报告将雨水水质列为长期目标。SEEDS 关于雨水花园与绿色雨水基础设施的工作显示，仍需围绕降雨测量温度、pH、电导率、溶解氧与浊度。",
    "note": "AquaWorks 在受控测试中以移动、空间分布观测补充固定设施——并非接管校园监测项目。"
  },
  "parameters": {
    "eyebrow": "第一阶段传感器",
    "title": "五项核心水质指标",
    "note": "用于刻画一般条件及空间/时间变化。不能确证特定污染物或法规合规。",
    "items": {
      "temperature": { "name": "温度", "description": "影响溶解氧、生物过程及其他指标表现。" },
      "ph": { "name": "pH", "description": "酸碱度，对生物活动与周边条件敏感。" },
      "turbidity": { "name": "浊度", "description": "悬浮颗粒的光学信号——有助于识别径流与雨水格局。" },
      "conductivity": { "name": "电导率", "description": "反映溶解离子含量；便于沿路线比较站点。" },
      "dissolvedOxygen": { "name": "溶解氧", "description": "对水生生物至关重要；第一阶段按制造商程序验证。" }
    }
  },
  "spatial": {
    "title": "空间与时间观测",
    "body": "读数与时间戳及空间参考关联——航点、路线段、可行时的 GPS，或既定试验区。同一路线上的降雨前后对比使变化可见。"
  },
  "viz": {
    "title": "从 CSV 到空间叙事",
    "body": "原始与处理后文件分开保存。输出包括路线图、时序与参数趋势，以及至少一幅用颜色或高度表示指标的空间图。插值假设有记录；测点保持可见。"
  },
  "sdgs": {
    "title": "与可持续发展目标对齐",
    "lead": "教育、清洁水认知、创新、可持续社区、负责任生产、气候韧性素养、水下生命与伙伴关系。",
    "items": {
      "education": "优质教育",
      "water": "清洁饮水与卫生设施",
      "innovation": "产业、创新与基础设施",
      "cities": "可持续城市和社区",
      "consumption": "负责任消费和生产",
      "climate": "气候行动",
      "lifeBelowWater": "水下生物",
      "partnerships": "促进目标实现的伙伴关系"
    }
  },
  "sources": {
    "title": "部分参考文献",
    "lead": "叙事参考提案中的同行评议研究、省级指南、温哥华校园规划文件与 SEEDS 报告。"
  }
}
